/** HTTP metadata shared by direct reads and the authenticated API helper. */
export class ApiError extends Error {
  readonly retryAfterMs: number;

  constructor(readonly status: number, retryAfter: string | null, message?: string) {
    super(status === 429 ? 'Busy, please try again shortly.' : message || `HTTP ${status}`);
    this.name = 'ApiError';
    const seconds = retryAfter && /^\d+(?:\.\d+)?$/.test(retryAfter.trim()) ? Number(retryAfter) : NaN;
    const dateDelay = retryAfter ? Date.parse(retryAfter) - Date.now() : NaN;
    const delay = Number.isFinite(seconds) ? seconds * 1000 : dateDelay;
    this.retryAfterMs = Number.isFinite(delay) ? Math.max(0, delay) : 0;
  }
}

export function retryApiRead(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500 && error.status !== 429) return false;
  // A timer beyond this range wraps in browsers. Leave long holds to an
  // explicit later retry instead of violating the server's Retry-After.
  if (error instanceof ApiError && error.retryAfterMs > 2_147_483_647) return false;
  return failureCount < 3;
}

export function apiReadRetryDelay(attempt: number, error: unknown): number {
  const backoff = Math.min(1000 * 2 ** attempt, 30_000);
  return Math.max(backoff, error instanceof ApiError ? error.retryAfterMs : 0);
}
